import { useMemo } from 'react'
import { Controller } from 'react-hook-form'
import Select from 'react-select'
import { MONTH_TH_FULL } from '../../utils/dateUtils'

const SelectMonth = ({ control, defaultValue }) => {

    const titleOptions = useMemo(() => {
        const monthTh = MONTH_TH_FULL.split(',')
        return monthTh.map((m, index) => {
            const value = (index + 1).toString().padStart(2, '0')
            return { value: value, label: m }
        })
    }, [])

    return (
        <Controller
            name="month"
            control={control}
            defaultValue={defaultValue && titleOptions.find(v=>v.value===defaultValue)}
            render={({ field }) => <Select options={titleOptions} placeholder="เลือก" {...field} isClearable />}
        />
    )
}

export default SelectMonth
